/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_Note_LabelInputs */



/**
* | output |
* | --- |
* | "Note" |
*
* @param {Promo_Movement_Note_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_note_label = /** @type {((inputs?: Promo_Movement_Note_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_Note_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Note")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nota")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nota")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nota")
	return /** @type {LocalizedString} */ ("Note")
});